import pairingApiDefinition from './api.js';

const pairing = () => ({
  id: 'pairing',
  definitions: [{ definition: pairingApiDefinition }],
});

export default pairing;
